import { render, staticRenderFns } from "./HelpCenter.vue?vue&type=template&id=7b1c6d7a&scoped=true"
import script from "./HelpCenter.vue?vue&type=script&lang=js"
export * from "./HelpCenter.vue?vue&type=script&lang=js"
import style0 from "./HelpCenter.vue?vue&type=style&index=0&id=7b1c6d7a&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1c6d7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b1c6d7a')) {
      api.createRecord('7b1c6d7a', component.options)
    } else {
      api.reload('7b1c6d7a', component.options)
    }
    module.hot.accept("./HelpCenter.vue?vue&type=template&id=7b1c6d7a&scoped=true", function () {
      api.rerender('7b1c6d7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/help/HelpCenter.vue"
export default component.exports